"use strict";

var _reactJss = require("react-jss");

// eslint-disable-next-line max-len
var importUrl = 'https://fonts.googleapis.com/css?family=Quicksand:300,400,500,700|Roboto:100,100i,300,300i,400,400i,500,500i,700,700i,900,900i';

var sheet = _reactJss.jss.createStyleSheet();

sheet.addRule(_reactJss.jss.createRule('@import', ["url(".concat(importUrl, ")")]));
sheet.attach();
//# sourceMappingURL=sheet.js.map